// extracted by mini-css-extract-plugin
export default {"form":"form_form__7y3bh","flex":"form_flex__xjJck"};